import { RootPage } from '../page';
import $api from '../../api';
import { UserModel } from '../../models/Gen/BaseModels';

class ProfileView extends RootPage {
    constructor() {
        super();

        this.user = ko.observable();
    }

    onInit() {
        this.user(new UserModel(this.getServerSideData('user')));
    }

    saveNotifications() {
        this.startSubmitting('notifs');
    }

    saveProfile() {
        this.startSubmitting();

        $api.users.updateProfile(
            {},
            this.user().toJS(),
            (resp) => {
                TRACK_EVENT('Users', 'Profile Updated');
                this.stopSubmitting();
                this.showToast('Profile updated.');
            }
        );
    }
}

export default ProfileView;